import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {RegularUnitAdvertisementDto, SeniorUnitAdvertisementDto} from "homey-housing-lottery-app-dto";
import {MinRentPipe} from "../../pipes/min-rent.pipe";
import {MaxRentPipe} from "../../pipes/max-rent.pipe";
import {DollarPipe} from "../../pipes/dollar.pipe";
import {TranslocoPipe} from "@jsverse/transloco";
import {RelevantApartmentsInput} from "../../pipes/apartment-relevant-advertisements.pipe";

@Component({
  selector: 'homey-rent-display',
  standalone: true,
  imports: [
    MinRentPipe,
    MaxRentPipe,
    DollarPipe,
    TranslocoPipe,
  ],
  template: `
    @let value = advertisements();
    @if (value.type === 'senior') {
      {{ 'common.price.seniorIncomeBased' | transloco }}
    } @else {
      @let ads = value.unitTypes;
      @if (ads.length > 0) {
        @let min = ads | minRent;
        @let max = ads | maxRent;
        @if (min === max) {
          {{ 'common.price.perMonth' | transloco : { value: (min | dollar) } }}
        } @else {
          {{ 'common.price.rangePerMonth' | transloco : { min: (min | dollar), max: (max | dollar) } }}
        }
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RentDisplayComponent {
  advertisements = input.required<{
    type: 'senior',
    unitTypes: SeniorUnitAdvertisementDto[]
  } | {
    type: 'regular',
    unitTypes: RegularUnitAdvertisementDto[]
  }>()
  relevantAdvertisementsInput = input.required<RelevantApartmentsInput>();
}
